// V2 Persona constants + helpers
// NOTE: insertion order matters — PERSONA_LIST uses Object.values which preserves it.
// "companion" intentionally first because it's the safest default for new
// visitors (we don't know yet whether they own a pet).
export const PERSONAS = {
  companion: { id: 'companion', emoji: '🌟', label: 'อยากช่วยและเรียนรู้', desc: 'ยังไม่มีน้อง แต่รักสัตว์', home: 'pet' },
  owner:     { id: 'owner',     emoji: '🐕', label: 'มีน้องเป็นของตัวเอง', desc: 'เลี้ยงสัตว์อยู่แล้ว',     home: 'pet' },
  caretaker: { id: 'caretaker', emoji: '🤝', label: 'ดูแลสัตว์ชุมชน',       desc: 'อาสา/ป้อนอาหารซอย',  home: 'companion' },
  spotter:   { id: 'spotter',   emoji: '🌿', label: 'ชอบสัตว์ป่า',          desc: 'ถ่ายรูป/บันทึก',     home: 'companion' },
};

export const PERSONA_LIST = Object.values(PERSONAS);

// Default persona used when nothing is stored yet (typical new-visitor path).
export const DEFAULT_PERSONA = 'companion';

export const INTERESTS = [
  { id: 'dog',      emoji: '🐕', label: 'หมา' },
  { id: 'cat',      emoji: '🐈', label: 'แมว' },
  { id: 'rabbit',   emoji: '🐇', label: 'กระต่าย' },
  { id: 'bird',     emoji: '🐦', label: 'นก' },
  { id: 'wildlife', emoji: '🌿', label: 'สัตว์ป่า' },
  { id: 'exotic',   emoji: '🦎', label: 'อื่นๆ' },
];

export const OWNERSHIP_TYPES = {
  owned:     { id: 'owned',     emoji: '🏠', label: 'มีเจ้าของ',  color: '#FF7A45', dash: false },
  stray:     { id: 'stray',     emoji: '🛟', label: 'สัตว์จร',     color: '#F59E0B', dash: true  },
  community: { id: 'community', emoji: '🏘️', label: 'ชุมชนเลี้ยง', color: '#3B82F6', dash: false },
  wildlife:  { id: 'wildlife',  emoji: '🌿', label: 'สัตว์ป่า',    color: '#10B981', dash: false },
};

const PERSONA_KEY = 'tl_v2_persona';
const INTERESTS_KEY = 'tl_v2_interests';

export function getStoredPersona() {
  try { return localStorage.getItem(PERSONA_KEY) || null; } catch { return null; }
}
export function setStoredPersona(p) {
  try { localStorage.setItem(PERSONA_KEY, p); } catch {}
}
export function getStoredInterests() {
  try {
    const raw = localStorage.getItem(INTERESTS_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch { return []; }
}
export function setStoredInterests(arr) {
  try { localStorage.setItem(INTERESTS_KEY, JSON.stringify(arr || [])); } catch {}
}
